
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo/face-embedding",
      function () {
        return require("private-next-pages/demo/face-embedding.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo/face-embedding"])
      });
    }
  